import { render, staticRenderFns } from "./addGoodsToStore.vue?vue&type=template&id=ba1edf5e&scoped=true"
import script from "./addGoodsToStore.vue?vue&type=script&lang=js"
export * from "./addGoodsToStore.vue?vue&type=script&lang=js"
import style0 from "./addGoodsToStore.vue?vue&type=style&index=0&id=ba1edf5e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba1edf5e",
  null
  
)

export default component.exports